import { useQuery } from '@tanstack/react-query';
import { API } from 'network/api';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setUserCountry } from 'store/auth';
import { selectToken, selectUserCountry } from 'store/auth/selectors';

const useCountryVerify = () => {
  const dispatch = useDispatch();
  const country = useSelector(selectUserCountry);
  const token = useSelector(selectToken);

  const { data: userCountry, isLoading } = useQuery({
    queryKey: ['user-country', { token }],
    queryFn: async () => {
      const res = await API.get('/user/verify');
      return res?.data;
    },
    select: (res) => res?.country,
    enabled: !country?.length,
  });

  useEffect(() => {
    if (isLoading || !userCountry) return;
    dispatch(setUserCountry(userCountry));
  }, [userCountry, isLoading, dispatch]);

  return null;
};

export default useCountryVerify;
